/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserFromJSON,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserFromJSONTyped,
    JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserToJSON,
} from './JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
 */
export interface JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    orderKey?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    orderSite?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    orderSubsidyFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    orderCafeFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    orderBenepoFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    orderPayFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    anaRecordNo?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    subTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    iss?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    sub?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    customerNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    menuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    useDate?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    returnDate?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    headCntTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    nightCntTotal?: number;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser>}
     * @memberof JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest
     */
    userList?: Array<JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUser>;
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestFromJSON(json: any): JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest {
    return JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderKey': !exists(json, 'orderKey') ? undefined : json['orderKey'],
        'orderSite': !exists(json, 'orderSite') ? undefined : json['orderSite'],
        'orderSubsidyFlag': !exists(json, 'orderSubsidyFlag') ? undefined : json['orderSubsidyFlag'],
        'orderCafeFlag': !exists(json, 'orderCafeFlag') ? undefined : json['orderCafeFlag'],
        'orderBenepoFlag': !exists(json, 'orderBenepoFlag') ? undefined : json['orderBenepoFlag'],
        'orderPayFlag': !exists(json, 'orderPayFlag') ? undefined : json['orderPayFlag'],
        'anaRecordNo': !exists(json, 'anaRecordNo') ? undefined : json['anaRecordNo'],
        'subTotal': !exists(json, 'subTotal') ? undefined : json['subTotal'],
        'iss': !exists(json, 'iss') ? undefined : json['iss'],
        'sub': !exists(json, 'sub') ? undefined : json['sub'],
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
        'menuNo': !exists(json, 'menuNo') ? undefined : json['menuNo'],
        'planId': !exists(json, 'planId') ? undefined : json['planId'],
        'useDate': !exists(json, 'useDate') ? undefined : json['useDate'],
        'returnDate': !exists(json, 'returnDate') ? undefined : json['returnDate'],
        'headCntTotal': !exists(json, 'headCntTotal') ? undefined : json['headCntTotal'],
        'nightCntTotal': !exists(json, 'nightCntTotal') ? undefined : json['nightCntTotal'],
        'userList': !exists(json, 'userList') ? undefined : ((json['userList'] as Array<any>).map(JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserFromJSON)),
    };
}

export function JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestToJSON(value?: JpCoBenefitoneBsdpBffDtoBffConfirmPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderKey': value.orderKey,
        'orderSite': value.orderSite,
        'orderSubsidyFlag': value.orderSubsidyFlag,
        'orderCafeFlag': value.orderCafeFlag,
        'orderBenepoFlag': value.orderBenepoFlag,
        'orderPayFlag': value.orderPayFlag,
        'anaRecordNo': value.anaRecordNo,
        'subTotal': value.subTotal,
        'iss': value.iss,
        'sub': value.sub,
        'customerNo': value.customerNo,
        'menuNo': value.menuNo,
        'planId': value.planId,
        'useDate': value.useDate,
        'returnDate': value.returnDate,
        'headCntTotal': value.headCntTotal,
        'nightCntTotal': value.nightCntTotal,
        'userList': value.userList === undefined ? undefined : ((value.userList as Array<any>).map(JpCoBenefitoneBsdpBffDtoBffConfirmPostRequestUserToJSON)),
    };
}

